import {locationContainer} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';
import baseEncounterDocumentLinkStatefullFormatterParams from 'src/js/lib/raw_rendering/base_encounter_document_link_statefull_formatter_params';

import LinkFormatter from './LinkFormatter';

export class EncounterDocumentLinkStatefullFormatter extends React.PureComponent {
  render() {
    const {rowData, searchParams} =
      baseEncounterDocumentLinkStatefullFormatterParams(this.props);

    return (
      <LinkFormatter
        route={'/case'}
        searchParams={searchParams}
        routeParamId={rowData.caseId}
        {...this.props}
      />
    );
  }
}

EncounterDocumentLinkStatefullFormatter.displayName =
  'EncounterDocumentLinkStatefullFormatter';

EncounterDocumentLinkStatefullFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

EncounterDocumentLinkStatefullFormatter.defaultProps = {
  value: undefined,
};

export default connect((state) => ({
  queryParameters:
    state[locationContainer.LOCATION_REDUCER_STATE_ID].parameters,
}))(EncounterDocumentLinkStatefullFormatter);
